import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './Divider.module.scss';

export default function Divider() {
  return <div className={Styles['divider']} />;
}
